import React from 'react'
import './FeaturedProject.css'
import { useScrollZoom } from '../../hooks/useScrollZoom'

// The file tag reads the project's own stack instead of a decorative
// number  extension comes from its first listed language.
const EXTENSION_BY_LANGUAGE = {
  react: 'jsx',
  'react native expo': 'jsx',
  'next.js': 'jsx',
  javascript: 'js',
  typescript: 'tsx',
  php: 'php',
  python: 'py',
  dart: 'dart',
  html: 'html',
  css: 'css',
}

const slugify = (text) =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')

const fileTag = (name, languages) => {
  const primary = languages[0]?.name?.toLowerCase()
  const ext = EXTENSION_BY_LANGUAGE[primary] || 'dev'
  return `${slugify(name)}.${ext}`
}

const FeaturedProject = ({ name, link, description, colour, languages }) => {
  const zoomRef = useScrollZoom()

  return (
    <a
      className="repo-row"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      ref={zoomRef}
    >
      <div className="repo-row-icon" style={{ background: colour }} aria-hidden="true">
        <svg viewBox="0 0 16 16" width="18" height="18">
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2 2.5A2.5 2.5 0 014.5 0h8.75a.75.75 0 01.75.75v12.5a.75.75 0 01-.75.75h-2.5a.75.75 0 110-1.5h1.75v-2H4.5a1 1 0 00-1 1v.25a.75.75 0 01-1.5 0zm10.5-1H4.5a1 1 0 00-1 1v6.708A2.486 2.486 0 014.5 9h8z"
          />
        </svg>
      </div>
      <div className="repo-row-main">
        <div className="repo-row-head">
          <span className="repo-row-name">{name}</span>
          <span className="repo-row-file">{fileTag(name, languages)}</span>
          <span className="repo-row-badge">destaque</span>
        </div>
        <p className="repo-row-desc">{description}</p>
        <div className="repo-row-langs">
          {languages.map((language) => (
            <span key={`${name}-${language.name}`} className="repo-lang">
              <span
                className="repo-lang-dot"
                style={{ backgroundColor: language.color }}
              />
              {language.name}
            </span>
          ))}
        </div>
      </div>
    </a>
  )
}

export default FeaturedProject
